import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

export default function Textarea({  name, ...rest  }) {
    const textareaRef = useRef(null);
    const { fieldName, registerField, defaultValue, error } = useField(name);

useEffect(() => {
    registerField({
        name: fieldName,
        ref: textareaRef.current,
        path: 'value'
    })
}, [fieldName, registerField ]);

    return (
        <div>
            <textarea ref={textareaRef} defaultValue={defaultValue} {...rest}/>
            {error && <span>{error}</span>}
        </div>
    );
}